import { render } from "./DonorReferralsTab.vue?vue&type=template&id=4fd38cae"
import script from "./DonorReferralsTab.vue?vue&type=script&lang=js"
export * from "./DonorReferralsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__